import React, { Dispatch, SetStateAction, useState, useEffect } from 'react'
import RoutineStyle from '../../../../components/Routine&Performance/RoutineUpload.module.css';
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    InputLabel,
    Select,
    MenuItem,
    styled,
    FormHelperText


} from '@mui/material';

import ProcessMapUploadForm from '../../Forms/ProcessMapUploadForm/ProcessMapUploadForm';
import { X } from 'lucide-react';
import { apiService } from '../../../../api/apiService';
import useFunctionOptions from '../../utils/useFunctionOptions';
import SuccessPopup from '../../Popup/Success&ErrorPopup/SuccessPopup';
import ErrorPopup from '../../Popup/Success&ErrorPopup/ErrorPopup';
// import { APP_URL } from '../../../../utils';


interface ProcessFile {
    id: string;
    name: string;
    date: string;
    functionL1: string;
    // functionL2: string;
    // functionL3: string;
    status: string;
    size: string;
}

interface ProcessMapPopupProps {
    openUpload: boolean;
    setOpenUpload: Dispatch<SetStateAction<boolean>>;
    management: string;
    verticalTabValue?: string;
    verticalTabValueTitle?:string;
    onSuccess?: () => void;


}

const StyledMenuItem = styled(MenuItem)({
    color: 'black', // Set the text color to black
    '&:hover': {
        backgroundColor: '#f0f0f0', // Optional: hover background color
    },
});



const FBSPopup: React.FC<ProcessMapPopupProps> = ({ openUpload, setOpenUpload, management, verticalTabValue, verticalTabValueTitle, onSuccess }) => {
    const { instance } = useMsal();
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [files, setFiles] = useState<ProcessFile[]>([]);
     const [showSuccess, setShowSuccess] = useState(false);
      const [showError, setShowError] = useState(false);    
      const [errorMessage, setErrorMessage] = useState('');    


 const [functionL1, setFunctionL1] = useState('');
  const [uploading, setUploading] = useState(false);
  // Use the custom hook to fetch options for each level
  const { options: l1Options, loading: l1Loading } = useFunctionOptions('l1', '');

    const [functionL1Error, setFunctionL1Error] = useState(false);


    // Mapping for file titles based on verticalTabValueTitle
    const fileTitleMapping = {
        a: "Provide documentation or training materials that show how continuous improvement methodologies (such as White Belt methodology, Lean, Six Sigma, or Agile) are being employed within the GBS. Evidence should include process improvement reports, initiatives, and results.",
        b: "Provide documentation that outlines chronic problems, how they were selected, and how PDCA (Plan-Do-Check-Act) was applied. Evidence should include problem selection criteria and action plans aligned with strategic objectives. Examples:  (e.g. criticality, repeatability, impact, etc.) ((examples: RCA (Root Cause Analysis) methodologies such as 5WHYs, fishbone diagrams, pareto, and impact analysis for problem-solving, PDCA's, etc)",
    };

     // Get the file title based on verticalTabValueTitle, or use a default value if not found
     const fileTitle = verticalTabValueTitle ? fileTitleMapping[verticalTabValueTitle as keyof typeof fileTitleMapping] : "Upload the file";
     console.log("File title:", fileTitle);


    const handleFileSelect = (file: File) => {
        setSelectedFile(file);
        // simulateUpload();
    };
    const currentYear = new Date().getFullYear();
    const years = Array.from(new Array(10), (val, index) => currentYear - 1 + index);
    const handleSubmit = async () => {

            if (!functionL1) {
                setFunctionL1Error(true);
                // setErrorMessage("Please select a Function L1");
                // setShowError(true);
                return;
            }

        if (selectedFile) {
            // Create a FormData instance
                    setFunctionL1Error(false);

            const formData = new FormData();

            // Create the process_map_req object
            const processMapReq = {
                // manager_id: "some_manager_id", 
                section_name: verticalTabValue,
                management: management, // Replace with actual data
                function_l1: functionL1,
                // month: functionL2,
                // year: functionL3,
            };

            // Append the process_map_req object as a JSON string
            formData.append("frontline_solution", JSON.stringify(processMapReq));
            formData.append("file", selectedFile); // Append the file as binary data

            console.log("Payload:", Array.from(formData.entries()));
            setUploading(true);
            try {
                const response = await apiService("/management/frontline_problem_solving", "POST", formData, undefined, instance as PublicClientApplication);

                if (response.error) {
                    console.error("Error submitting process map:", response.error);
                    return;
                }

                console.log("Submission successful:", response);

                setFiles([
                    {
                        id: Math.random().toString(36).substr(2, 9),
                        name: selectedFile.name,
                        date: new Date().toLocaleDateString(),
                        functionL1,
                        // functionL2,
                        // functionL3,
                        status: "Submitted",
                        size: `${Math.round(selectedFile.size / 1024)} KB`,
                    },
                    ...files,
                ]);

                setOpenUpload(false);
                resetUploadState();
                setShowSuccess(true);
                if (onSuccess) {
                    onSuccess(); // Call the callback function after successful upload
                }
            } catch (error) {
                console.error("Error during submission:", error);
            } finally {
                setUploading(false);
            }

        }
    };
    const resetUploadState = () => {
        setSelectedFile(null);
        setUploadProgress(0);
        setFunctionL1('');
        // setFunctionL2('');
        // setFunctionL3('');
    };

       useEffect(() => {
            let timer: NodeJS.Timeout;
            if (showSuccess) {
                timer = setTimeout(() => {
                    setShowSuccess(false);
                }, 3000);
            }
            return () => clearTimeout(timer);
        }, [showSuccess]);
    
        useEffect(() => {
            let timer: NodeJS.Timeout;
            if (showError) {
                timer = setTimeout(() => {
                    setShowError(false);
                }, 3000);
            }
            return () => clearTimeout(timer);
        }, [showError]);


    return (
        <>
        <Dialog
            open={openUpload}
            onClose={() => {
                setOpenUpload(false);
                resetUploadState();
            }}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#000' }}>
                {verticalTabValue}
                <IconButton onClick={() => setOpenUpload(false)}>
                    <X size={20} />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Function L1 *</InputLabel>
                        <Select
                            sx={{ borderRadius: '8px', color: '#000' }}
                            value={functionL1}
                            label="Function L1 *"
                            onChange={(e) => {
                                setFunctionL1(e.target.value);
                                setFunctionL1Error(false); 
                            }}
                        >

                            <StyledMenuItem value="">
                                Select Function L1
                            </StyledMenuItem>
                            {l1Options.map((option, index) => (
                                <StyledMenuItem key={index} value={option}>
                                    {option}
                                </StyledMenuItem>
                            ))}

                        </Select>
                        {functionL1Error && (
                                <FormHelperText sx={{color: 'red'}}>This field is required</FormHelperText>
                            )}
                    </FormControl>



                </Box>
                <ProcessMapUploadForm
                    file={selectedFile}
                    onFileSelect={handleFileSelect}
                    onFileRemove={() => {
                        setSelectedFile(null);
                        setUploadProgress(0);
                    }}
                    uploadProgress={uploadProgress}
                    fileTitle={fileTitle} // Use the dynamically determined file title
                />
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button variant='outlined' onClick={() => setOpenUpload(false)} sx={{ color: '#000', borderColor: '#000' }}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!selectedFile || uploading}
                    sx={{
                        color: 'white',
                        bgcolor: 'black',
                        '&:hover': { bgcolor: 'black' },
                        '&:disabled': { bgcolor: 'grey.300' },
                    }}
                >
                    {uploading ? 'Uploading...' : 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>

         {/* Success Popup */}
         <SuccessPopup
                open={showSuccess}
                onClose={() => setShowSuccess(false)}
                message={`${verticalTabValue} uploaded successfully`}
            />

            {/* Error Popup */}
            <ErrorPopup
                open={showError}
                onClose={() => setShowError(false)}
                message={errorMessage}
            />

        </>
    )
}

export default FBSPopup
